import { Component, OnInit } from '@angular/core';
import { AlertService } from '@app/core/services/alert.service';
import { ServiceRequestService } from '@app/api/dmc';
import { FormApiService } from '@app/core/services/form-api.service';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  templateUrl: './service-request-remove-modal.component.html',
  imports: [
    TranslatePipe,
    ReactiveFormsModule,
    InputGroupComponent,
    LabelDirective,
    InputDirective
  ]
})
export class ServiceRequestRemoveModalComponent implements OnInit, HasUnsavedChanges {

  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public form: FormGroup = new FormGroup({
    serviceRequestId: new FormControl(null, Validators.required),
    meteringPointIdentification: new FormControl(null, Validators.required),
    date: new FormControl(this.getTodayDateString(), Validators.required),
    isCancelledBySupplier: new FormControl(null, Validators.required),
  })

  public element?: any;

  constructor(
    private readonly alertService: AlertService,
    private readonly serviceRequestService: ServiceRequestService,
    private readonly formApiService: FormApiService,
  ) {
    this.alertService.info('modal', 'dashboard.servicerequest.remove.info')
  }

  public ngOnInit(): void {
    if (this.element) {
      this.form.get('serviceRequestId')?.setValue(this.element.serviceRequestId);
      this.form.get('meteringPointIdentification')?.setValue(this.element.meteringPointIdentification);
      this.form.get('isCancelledBySupplier')?.setValue(this.element.isCancelledBySupplier);
    }
  }

  private getTodayDateString(): string {
    return new Date().toISOString().substring(0, 10);
  }

  public submit(): void {
    this.formApiService.submit(
      this.form,
      (data) => this.serviceRequestService.serviceRequestHandleProcessCancelledBySupplierPost(data),
      {
        closeModal: true,
        successMessage: 'dashboard.servicerequest.remove.success'
      }
    )
  }

}
